export const DEFAULT_PAGE_SIZES = [
  { value: 10, label: 'Show 10' },
  { value: 20, label: 'Show 20' },
  { value: 50, label: 'Show 50' },
  { value: 100, label: 'Show 100' }
]